import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar";
import { NavBar } from "../Navbar/NavBar";
import "../../Assets/CSS/bulkorder.css";
import { useNavigate, useParams } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import "../OMS/oms.css";
import DoneIcon from "@mui/icons-material/Done";
import axios from "axios";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { ClipLoader } from "react-spinners";
import BuyerSide from "./orderDetails/buyerSide";
import SupplierSide from "./orderDetails/supplierSide";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useFormik } from "formik";
import {
  Button,
  TextField,
} from "@mui/material";

function View() {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [omsData, setOmsData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("purchase");
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const IsDepartmentHead = localStorage.getItem("IsDepartmentHead");
  const IsRm = localStorage.getItem("IsRm");
  const IsSe = JSON.parse(localStorage.getItem("IsSe"));
  const [open, setOpen] = useState(false);
  const [state, setState] = useState({
    "Supplier Details": "Incomplete",
    "Supplier PO, BOS": "Incomplete",
    "Supplier Loading Details": "Incomplete",
    "Supplier Transport Details": "Incomplete",
    "Buyer PO, BOS": "Incomplete",
    "Buyer Unloading Details": "Incomplete",
    "Buyer Transport Details": "Incomplete",
    "Buyer Rejection Details": "Incomplete",
  });

  const [approvalStatus, setApprovalStatus] = useState({
    l1_first_status: "",
    l1_second_status: "",
    l2_status: "",
    l3_first_status: "",
    l3_second_status: "",
  });
  const navigate = useNavigate();

  const handleSubmit = async (data) => {
    const url = `/workflowapi/level1_multi_approve`;

    const payload = {
      order_id: id,
      tenure: data.tenure,
      lvl_actioner_name: userDetails?.user_name,
      email_address_of_logged_user: userDetails?.email_address,
      lvl1_actioner_id: userDetails?.id,
    };
    try {
      const { data } = await axios.post(url, payload);
      if (data.error) {
        console.log(data);
      } else {
        toast.success(data.message);
        handleModalClose();
      }

      getOMSData();
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.error.message);
      console.log(error);
      handleModalClose();
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.tenure) {
      errors.tenure = "Tenure is Required";
    }

    return errors;
  };
  const formik = useFormik({
    initialValues: { tenure: null },
    validate,
    onSubmit: handleSubmit,
  });

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    //   border: "2px solid #000",
    boxShadow: 24,
    //   pt: 2,
    //   px: 4,
    //   pb: 3,
    p: 2,
  };

  const handleModalClose = () => {
    formik.resetForm();
    setOpen(false);
  };

  const handleModalOpen = () => {
    setOpen(true);
  };

  const getOMSData = async () => {
    const url = `/api/oms/orders/${id}`;
    try {
      setLoading(true);
      const { data } = await axios.get(url);
      if (data.status) {
        setOmsData(data?.order_details);
        let supplierDoc = data?.order_details?.operations_po_bos_uploads?.find(
          (obj) => obj.merchant_type === "supplier"
        );
        let buyerDoc = data?.order_details?.operations_po_bos_uploads?.find(
          (obj) => obj.merchant_type === "buyer"
        );
        let transportSupplier = data?.order_details?.order_shipment_docs?.find(
          (obj) => obj.merchant_type === "supplier"
        );
        let transportBuyer = data?.order_details?.order_shipment_docs?.find(
          (obj) => obj.merchant_type === "buyer"
        );
        setState((prev) => ({
          ...prev,
          "Supplier Loading Details": data?.order_details?.supplier_loading
            ? "Complete"
            : "Incomplete",
          "Supplier Details": isEmptyObject(
            data?.order_details?.op_sourcing_details?.[0] || {}
          )
            ? "Incomplete"
            : "Complete",
          "Supplier PO, BOS": isEmptyObject(supplierDoc || {})
            ? "Incomplete"
            : "Complete",
          "Buyer PO, BOS": isEmptyObject(buyerDoc || {})
            ? "Incomplete"
            : "Complete",
          "Supplier Transport Details": transportSupplier
            ? "Complete"
            : "Incomplete",
          "Buyer Unloading Details": data?.order_details?.buyer_unloading
            ? "Complete"
            : "Incomplete",
          "Buyer Transport Details": transportBuyer ? "Complete" : "Incomplete",
          "Buyer Rejection Details": isEmptyObject(
            data?.order_details?.oms_standby || {}
          )
            ? "Incomplete"
            : "Complete",
        }));

        switch (data?.order_details?.only_bnps?.ayekart_loan_status) {
          case "Rejected":
            setApprovalStatus((prev) => ({
              ...prev,
              l1_first_status: "Rejected",
              l1_second_status: "Rejected",
              l2_status: "Rejected",
              l3_first_status: "Rejected",
              l3_second_status: "Rejected",
            }));
            break;
          case "Pending_dh":
            setApprovalStatus((prev) => ({
              ...prev,
              l1_first_status: "",
              l1_second_status: "",
              l2_status: "",
              l3_first_status: "Pending From Department Head",
              l3_second_status: "Pending From Department Head",
            }));

            break;
          case "Pending":
            setApprovalStatus((prev) => ({
              ...prev,
              l1_first_status: "",
              l1_second_status: "Pending For Approval From RM",
              l2_status: "Pending For Approval From RM",
              l3_first_status: "Pending For Approval From RM",
              l3_second_status: "Pending For Approval From RM",
            }));

            break;
          case "Pending_2nd_LVL1":
            setApprovalStatus((prev) => ({
              ...prev,
              l1_first_status: "",
              l1_second_status: "",
              l2_status: "Pending For Approval From OPES Finance",
              l3_first_status: "Pending For Approval From OPES Finance",
              l3_second_status: "Pending For Approval From OPES Finance",
            }));

            break;
          case "Pending_lvl2":
            setApprovalStatus((prev) => ({
              ...prev,
              l1_first_status: "",
              l1_second_status: "",
              l2_status: "",
              l3_first_status: "",
              l3_second_status: "",
            }));

            break;
          case "Pending_2nd_LVL2":
            setApprovalStatus((prev) => ({
              ...prev,
              l1_first_status: "",
              l1_second_status: "",
              l2_status: "",
              l3_first_status: "",
              l3_second_status: "",
            }));
            break;
        }
      } else {
        toast.error(data.message);
        setOmsData([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  function isEmptyObject(obj) {
    return Object.keys(obj).length === 0 && obj?.constructor === Object;
  }


  useEffect(() => {
    getOMSData();
  }, []);

  const handleL1Approve = async () => {
    const url = `/workflowapi/level1_multi_approve`;

    const payload = {
      order_id: id,

      lvl_actioner_name: userDetails?.user_name,
      email_address_of_logged_user: userDetails?.email_address,
      lvl1_actioner_id: userDetails?.id,
    };
    try {
      const { data } = await axios.post(url, payload);
      if (data.error) {
        console.log(data);
      } else {
        toast.success(data.message);
      }

      getOMSData();
    } catch (error) {
      setLoading(false);
      toast.error(error.response.data.error.message);
      console.log(error);
    }
  };

  const handleL1Reject = async () => {
    const url = `/workflowapi/level1_multi_reject/`;

    const payload = {
      order_id: id,
      lvl_actioner_name: userDetails?.user_name,
      email_address_of_logged_user: userDetails?.email_address,
    };

    try {
      const { data } = await axios.post(url, payload);
      toast.success(data.message);
      getOMSData();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleL2Approve = async () => {
    const url = `/workflowapi/level2_department_head_approve`;

    const payload = {
      order_id: id,

      lv2_actioner_name: userDetails?.user_name,
    };
    try {
      const { data } = await axios.post(url, payload);
      toast.success(data.message);
      getOMSData();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleL2Reject = async () => {
    const url = `/workflowapi/level2_department_head_reject`;

    const payload = {
      order_id: id,
      lv2_actioner_name: userDetails?.user_name,
    };

    try {
      const { data } = await axios.post(url, payload);
      toast.success(data.message);
      getOMSData();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleL3Approve = async () => {
    const url = `/workflowapi/level3_multi_approve`;

    const payload = {
      order_id: id,
      lv3_actioner_name: userDetails?.user_name,
      lvl3_actioner_id: userDetails?.id,
    };
    try {
      const { data } = await axios.post(url, payload);
      toast.success(data.message);
      getOMSData();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleL3Reject = async () => {
    const url = `/workflowapi/level3_multi_reject`;

    const payload = {
      order_id: id,
      lv3_actioner_name: userDetails?.user_name,
    };

    try {
      const { data } = await axios.post(url, payload);
      toast.success(data.message);
      getOMSData();
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  console.log(approvalStatus);

  return (
    <div className="flex">
      {/* <Sidebar /> */}
      <Modal
        className="p-0"
        open={open}
        onClose={handleModalClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h5 id="child-modal-title">Tenure</h5>
          <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />
          <div>
            <form onSubmit={formik.handleSubmit}>
              <div className="row mt-3">
                <div className="">
                  <TextField
                    size="small"
                    fullWidth
                    name="tenure"
                    onChange={formik.handleChange}
                    type="number" onWheel={(e) => e.target.blur()}
                    label="Tenure"
                  />
                  {formik.errors.tenure ? (
                    <div className="text-red-600 text-sm">
                      {formik.errors.tenure}
                    </div>
                  ) : null}
                </div>
              </div>

              <hr className="font-bold text-neutral-500 bg-gray-900 h-0.5" />

              <div className="mt-3 flex">
                <Button
                  fullWidth
                  variant="contained"
                  className="me-3"
                  style={{ backgroundColor: "#131542" }}
                  type="submit"
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  fullWidth
                  style={{ backgroundColor: "#C7081E" }}
                  type="button"
                  onClick={() => handleModalClose()}
                >
                  Close
                </Button>
              </div>
            </form>
          </div>
        </Box>
      </Modal>
      <div className="mt-3 ml-8 builk-main " >
        {/* <NavBar /> */}
        {loading ? (
          <div className="text-center" style={{ marginTop: "50vh" }}>
            <ClipLoader />
          </div>
        ) : (
          <div className=" ms-0 ps-0 mt-2 m-4 pt-4  ml-8">
            <div className="flex justify-start">
              <span
                role="button"
                className="fw-bolder"
                onClick={() => navigate("/oms")}
              >
                OMS
              </span>{" "}
              <span role="button" className="fw-bolder">
                {" "}
                <ChevronRightIcon />
                View Order #{id}
              </span>
            </div>
            <h4 className="flex justify-start mt-2">Order #{id}, Order Type: {omsData?.order_type || 'NA'}</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 shadow-lg rounded-md mt-4">
              <div className="shadow-md ">
                <div className="flex justify-start items-center p-3">
                  <div
                    className="flex justify-center ms-2 items-center shadow-md text-center rounded-md  w-16 h-16 text-white"
                    style={{ backgroundColor: "#DC7676" }}
                  >
                    <div className="fw-bolder">L1</div>
                  </div>
                  <div className="ml-4 ">
                    <div className="border-2 p-2 mb-1 text-sm">
                      {omsData?.only_bnps?.lvl1_actioner ? (
                        <div>
                          <div className="flex items-center ">
                            <span className="">Approved by: </span>
                            <span className="">
                              {omsData?.only_bnps?.lvl1_actioner
                                ? omsData?.only_bnps?.lvl1_actioner
                                : "NA"}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <span className="">Approved on: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.lvl1_stamp
                                ? moment(omsData?.only_bnps?.lvl1_stamp).format(
                                    "MM/DD/YYYY, h:mm a"
                                  )
                                : "NA"}
                            </span>
                          </div>
                        </div>
                      ) : approvalStatus.l1_first_status === "" ? (
                        !omsData?.only_bnps?.lvl1_actioner &&
                        IsRm !== "false" && (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                            <div className="flex">
                              <button
                                className="bg-green-900 text-white p-2 rounded mr-2 w-32"
                                onClick={() => {
                                  handleL1Approve();
                                }}
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => handleL1Reject()}
                                className="bg-red-900 text-white p-2 rounded w-32"
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        )
                      ) : (
                        <div>
                          <h1 className="text-sm">
                            {approvalStatus.l1_first_status}
                          </h1>
                        </div>
                      )}
                    </div>
                    <div className="border-2 p-2 text-sm">
                      {omsData?.only_bnps?.lvl1_second_actioner ? (
                        <div>
                          <div className="flex items-center">
                            <span className="">Approved by: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.lvl1_second_actioner
                                ? omsData?.only_bnps?.lvl1_second_actioner
                                : "NA"}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <span className="">Approved on: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.ayekart_lvl1_second_stamp
                                ? moment(
                                    omsData?.only_bnps
                                      ?.ayekart_lvl1_second_stamp
                                  ).format("MM/DD/YYYY, h:mm a")
                                : "NA"}
                            </span>
                          </div>
                        </div>
                      ) : approvalStatus.l1_second_status === "" ? (
                        !omsData?.only_bnps?.lvl1_second_actioner &&
                        IsSe?.includes("oa_lvl1_wt") ? (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                            <div className="flex">
                              <button
                                onClick={() => {
                                  if (IsSe?.includes("oa_lvl1_wt")) {
                                    handleModalOpen();
                                  } else {
                                    handleL1Approve();
                                  }
                                }}
                                className="bg-green-900 text-white p-2 rounded mr-2 w-32"
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => handleL1Reject()}
                                className="bg-red-900 text-white p-2 rounded w-32"
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <h1 className="text-sm">
                              Pending For Approval From OPES Finance
                            </h1>
                          </div>
                        )
                      ) : (
                        <div>
                          <h1 className="text-sm">
                            {approvalStatus.l1_second_status}
                          </h1>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="shadow-md ">
                <div className="flex justify-start items-center p-3">
                  <div
                    className="flex justify-center ms-2 items-center shadow-md text-center w-16 h-16 text-white rounded-md mt-4"
                    style={{ backgroundColor: "#233F61" }}
                  >
                    <div className="fw-bolder">L2</div>
                  </div>
                  <div className="ml-4">
                    <div className="border-2 p-2 text-sm">
                      {omsData?.only_bnps?.department_head_actioner ? (
                        <div>
                          <div className="flex items-center">
                            <span className="">Approved by: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.department_head_actioner
                                ? omsData?.only_bnps?.department_head_actioner
                                : "NA"}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <span className="">Approved on: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.department_head_timestamp
                                ? moment(
                                    omsData?.only_bnps
                                      ?.department_head_timestamp
                                  ).format("MM/DD/YYYY, h:mm a")
                                : "NA"}
                            </span>
                          </div>
                        </div>
                      ) : approvalStatus.l2_status === "" ? (
                        !omsData?.only_bnps?.department_head_actioner &&
                        IsDepartmentHead !== "false" ? (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                            <div className="flex">
                              <button
                                onClick={() => handleL2Approve()}
                                className="bg-green-900 text-white p-2 rounded mr-2 w-32"
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => handleL2Reject()}
                                className="bg-red-900 text-white p-2 rounded w-32"
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <h1 className="text-sm">
                              Pending From Department Head
                            </h1>
                          </div>
                        )
                      ) : (
                        <div>
                          <h1 className="text-sm">
                            {approvalStatus.l2_status}
                          </h1>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="shadow-md ">
                <div className="flex justify-start items-center p-3">
                  <div
                    className="flex justify-center ms-2 items-center shadow-md text-center  w-16 h-16 text-white rounded-md"
                    style={{ backgroundColor: "#45B679" }}
                  >
                    <div className="fw-bolder">L3</div>
                  </div>
                  <div className="ml-4 ">
                    <div className="border-2 p-2 mb-1 text-sm">
                      {omsData?.only_bnps?.lvl2_actioner ? (
                        <div>
                          <div className="flex items-center ">
                            <span className="">Approved by: </span>
                            <span className="">
                              {omsData?.only_bnps?.lvl2_actioner
                                ? omsData?.only_bnps?.lvl2_actioner
                                : "NA"}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <span className="">Approved on: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.lvl2_stamp
                                ? moment(omsData?.only_bnps?.lvl2_stamp).format(
                                    "MM/DD/YYYY, h:mm a"
                                  )
                                : "NA"}
                            </span>
                          </div>
                        </div>
                      ) : approvalStatus.l3_first_status === "" ? (
                        !omsData?.only_bnps?.lvl2_actioner &&
                        IsSe?.includes("oa_lvl2") ? (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                            <div className="flex">
                              <button
                                onClick={() => handleL3Approve()}
                                className="bg-green-900 text-white p-2 rounded mr-2 w-32"
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => handleL3Reject()}
                                className="bg-red-900 text-white p-2 rounded w-32"
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                          </div>
                        )
                      ) : (
                        <div>
                          <h1 className="text-sm">
                            {approvalStatus.l3_first_status}
                          </h1>
                        </div>
                      )}
                    </div>
                    <div className="border-2 p-2 text-sm">
                      {omsData?.only_bnps?.lvl2_second_actioner ? (
                        <div>
                          <div className="flex items-center">
                            <span className="">Approved by: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.lvl2_second_actioner
                                ? omsData?.only_bnps?.lvl2_second_actioner
                                : "NA"}
                            </span>
                          </div>
                          <div className="flex items-center">
                            <span className="">Approved on: </span>
                            <span className="ml-1">
                              {omsData?.only_bnps?.ayekart_lvl2_second_stamp
                                ? moment(
                                    omsData?.only_bnps
                                      ?.ayekart_lvl2_second_stamp
                                  ).format("MM/DD/YYYY, h:mm a")
                                : "NA"}
                            </span>
                          </div>
                        </div>
                      ) : approvalStatus.l3_second_status === "" ? (
                        !omsData?.only_bnps?.lvl2_second_actioner &&
                        omsData?.only_bnps?.lvl2_actioner &&
                        omsData?.only_bnps?.lvl2_actioner !==
                          userDetails?.user_name &&
                        IsSe?.includes("oa_lvl2") ? (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                            <div className="flex">
                              <button
                                onClick={() => handleL3Approve()}
                                className="bg-green-900 text-white p-2 rounded mr-2 w-32"
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => handleL3Reject()}
                                className="bg-red-900 text-white p-2 rounded w-32"
                              >
                                Reject
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <h1 className="text-sm">Pending For Approval</h1>
                          </div>
                        )
                      ) : (
                        <div>
                          <h1 className="text-sm">
                            {approvalStatus.l3_second_status}
                          </h1>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <ol className="grid grid-cols-4 gap-2">
                {Object.keys(state).map((each, index) => (
                  <li key={index}>
                    <div
                      className={`w-full p-2 border rounded-lg ${
                        state[each] === "Complete"
                          ? "text-green-700 border-green-300 bg-green-50"
                          : "text-red-700 border-red-300 bg-red-50"
                      }`}
                    >
                      <div className="flex justify-between">
                        <div className="self-center mt-2">
                          <h3 className="text-lg ">{each}</h3>
                        </div>

                        <div className="self-center">
                          {state[each] === "Complete" ? (
                            <DoneIcon />
                          ) : (
                            <PriorityHighIcon />
                          )}
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>

            <div className="text-sm font-medium text-center text-gray-500 mt-3">
              <ul className="flex flex-wrap -mb-px">
                <li className="me-2">
                  <span
                    className={`inline-block p-2 cursor-pointer  rounded-t-lg ${
                      selectedTab === "purchase" &&
                      "active border-blue-900 text-blue-900 border-b-2"
                    }`}
                    onClick={() => setSelectedTab("purchase")}
                  >
                    Purchase (Supplier)
                  </span>
                </li>
                <li className="me-2">
                  <span
                    href="#"
                    className={`inline-block p-2 cursor-pointer rounded-t-lg ${
                      selectedTab === "sale" &&
                      "active border-blue-900 text-blue-900 border-b-2"
                    }`}
                    onClick={() => setSelectedTab("sale")}
                  >
                    Sale (Buyer)
                  </span>
                </li>
              </ul>
            </div>

            <div>
              {selectedTab === "purchase" && (
                <SupplierSide
                  omsData={omsData}
                  getOMSData={getOMSData}
                  id={id}
                />
              )}
              {selectedTab === "sale" && (
                <BuyerSide omsData={omsData} getOMSData={getOMSData} id={id} />
              )}
            </div>
          </div>
        )}
      </div>

      <Toaster />
    </div>
  );
}

export default View;
